import { Modal, ProgressIndicator } from "@veneer/core";

type props = {
  id: string,
  setOpenCloseModal: ()=> void,
  openModal: boolean,
  titleMessage: string,
  message: string,
}

export const ModalMessageLoading = ({
  id,
  setOpenCloseModal,
  openModal,
  titleMessage,
  message,
}: props) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        align="center"
        id={id}
        show={openModal}
        onClose={setOpenCloseModal}
        title={titleMessage}
      >
        <p>{message}</p>
        <ProgressIndicator appearance="linear" behavior="indeterminate" />
      </Modal>
    </div>
  );
};
